<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xs="12">
        <v-toolbar flat width="100%">
          <v-toolbar-title class="pl-3 banner-title blue--text">
            Departed Vessels</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <div>
            <addVessel class="pr-3" />
          </div>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-col cols="12">
      <v-data-table
        :headers="header"
        item-key="id"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :items="departed_vessels"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            label="Search"
            class="mx-4"
          ></v-text-field>
        </template>
         <template v-slot:[`item.date_time_added`]="item">
          <span>{{ item.item.date_time_added | formatDateTime }}</span>
        </template>

        <template v-slot:[`item.actions`]="item">
          <template>
            <!-- <v-icon
              small
              class="mr-2;"
              style="cursor: pointer"
              @click="doAction({ item: item })"
            >
              mdi-location-exit
            </v-icon>
            <v-icon
              small
              class="mr-2;"
              style="cursor: pointer"
              @click="doAction({ item: item })"
            >
              mdi-eye
            </v-icon> -->
            <div>
              <!--<v-btn
                icon
                class="grey lighten-4 mx-2"
                @click="doAction({ item: item })">
                <v-icon>mdi-location-exit</v-icon>
              </v-btn>-->
              <v-btn
                icon
                class="grey lighten-4 mx-2"
                @click="doAction({ item: item })"
              >
                <view-vessel />
              </v-btn>
              <v-btn
                icon
                class="grey lighten-4 mx-2"
                @click="doAction({ name: 'set_depart', item: item })"
              >
                <setDepartedDateForm :props_data="{ detail: 'test props' }" />
              </v-btn>
            </div>
          </template>
        </template>
      </v-data-table>
    </v-col>
  </v-container>
</template>

<script>
const addVessel = () => import("./add-vessel");
const setDepartedDateForm = () => import("./set_vessel_departed_form");
const viewVessel = () => import("./dialog-view-vessel");
import { createNamespacedHelpers } from "vuex";
const departedVessel = createNamespacedHelpers("departed_vessels");

export default {
  components: {
    addVessel,
    setDepartedDateForm,
    viewVessel
  },
  data: () => ({
    activeItem: null,
    menu: null,
    show: false,
    selected_item: null,
    filteredList: null,
    search: "",
    menu_items: [
      { title: "view item", ref: "view_item" },
      { title: "edit item", ref: "edit_item" }
    ]
  }),

  computed: {
    ...departedVessel.mapState({
      departed_vessels: state => state.departed_vessels,
      loading: state => state.loading
    }),

    /* items() {
      return [
        { vessel_name: "vessel 01", voyage_num: "123456" },
        { vessel_name: "vessel 02", voyage_no: "765432" }
      ];
    },*/
    header() {
      return [
        { text: "Vessel Name", value: "vessel_name" },
        //{ text: "Shipping Line", value: "shipping_line" },
        { text: "Vogaye No", value: "voyage_number" },
        { text: "Arrival Date", value: "arrival_date" },
        // { text: "Arrival Time", value: "arrival_time" },
        { text: "Departure Date", value: "departure_date" },
        //  { text: "Departure Time", value: "departure_time" },
        { text: "Date Added", value: "date_time_added" },
        { text: "Action", value: "actions", align: "end", sortable: false }
      ];
    }
  },
  mounted() {
    this.initialize();
    console.log("loading", this.loading);
  },
  methods: {
    ...departedVessel.mapActions(["fetchDepartedVessels", "asetSelectedVessel"]),

    doAction(item) {
      console.log("action", item.item);
      this.selected_item = item.item;
      this.asetSelectedVessel(this.selected_item);
     /* if (item.name === "set_depart") {
        this.selected_item = item.item;
        this.asetSelectedVessel(this.selected_item);
      }*/
    },
    filterOnlyCapsText(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value.toString().indexOf(search) !== -1
      );
    },

    initialize() {
      this.fetchDepartedVessels();
      this.desserts = [
        {
          name: "Frozen Yogurt",
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0
        },
        {
          name: "Ice cream sandwich",
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3
        }
      ];
    },
    async getDepartedVessels() {}
  }
};
</script>

<style scoped>
.list {
  width: 100%;
}
</style>
